
import React, { useEffect,  useState } from "react";

import { AudioWaveform, Blocks, ChevronDown, ChevronUp, Fan, Info, Video } from "lucide-react";

import PlayerPageCardSectionsContents from "./PlayerPageCardSectionsContents";

const PlayerPageSectionCard =({courseId,playerCard1Object,setCurrentItem,contentItem})=>{
  
               const [openSection, setOpenSection] = useState(true);
      
                              
    return(<> {
   <div style={{background:`${playerCard1Object?.section?.bgColor?.color}`,
border:` ${playerCard1Object?.section?.border?.borderWidth?.value+playerCard1Object?.section?.border?.borderWidth?.resolution} ${playerCard1Object?.section?.border?.borderType}  ${playerCard1Object?.section?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${playerCard1Object?.section?.borderRadius?.topLeft?.value}${playerCard1Object?.section?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.section?.borderRadius?.topRight?.value}${playerCard1Object?.section?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.section?.borderRadius?.bottomLeft?.value}${playerCard1Object?.section?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.section?.borderRadius?.bottomRight?.value}${playerCard1Object?.section?.borderRadius?.bottomRight?.resolution}`,
              marginBottom:"12px",padding:"5px"}}>
    <div className="sidebarCardSectionInner" >
    <div >
    <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
        <Blocks size={26} color={playerCard1Object?.section?.textColor?.color} />
    <div className="player-cardTitleFont"  style={{fontSize:"16px",fontWeight:"800",margin:"0px",color:`${playerCard1Object?.section?.textColor?.color}`}}>{playerCard1Object?.section?.title} {contentItem?.Name} </div>

    </div><div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px",margin:"7px"}}>
  
   {contentItem?.counts?.chapters? <span  className="player-cardTagsFont"  style={{fontSize:"10px",color:`${playerCard1Object?.section?.textColor?.color}`}}>{contentItem?.counts?.chapters} Chapters</span>:""}
    {contentItem?.counts?.folders? <span  className="player-cardTagsFont"  style={{fontSize:"10px",color:`${playerCard1Object?.section?.textColor?.color}`}}>{contentItem?.counts?.folders} Folder</span>:""}
    </div>    </div>
   
 {openSection?  <div onClick={()=>{setOpenSection(false)}} style={{background:`${playerCard1Object?.section?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}}  ><ChevronUp size={22}  color={playerCard1Object?.section?.iconColor?.color}/></div> 
: <div onClick={()=>{setOpenSection(true)}} style={{background:`${playerCard1Object?.section?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}}  ><ChevronDown size={22}  color={playerCard1Object?.section?.iconColor?.color}/></div> 
   }
</div>
{openSection?<PlayerPageCardSectionsContents courseId={courseId}  playerCard1Object={playerCard1Object} setCurrentItem={(v)=>{setCurrentItem(v)}} sectionId={contentItem?.ID} />:""}

</div>}
    </>)
}
export default PlayerPageSectionCard

